export default __webpack_public_path__ + "static/media/chatbot.dd930ee4.png";